export enum SignalStateEnum {
    None = 0,
    Normal = 1,
    Abnormal = 2
}  

export enum SignalFeedbackEnum {
    None = 1,
    Abnormal = 2,
    Normal = 3
}  

export enum SortType {
    Asc = 'asc',
    Desc = 'desc'
}

export enum SignalStateIndexEnum {
    None = 0,
    Abnormal = 1,
    Normal = 2
}  